import React from "react";

var ChatBubblesIcon = function ChatBubblesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 13h1.5a6.5 6.5 0 1 0 0-13h-5A6.498 6.498 0 1 0 5 12.819V16zm9.774-4.583C18.901 12.182 15.527 15 11.5 15h-.946l-3.895 2.337A6.494 6.494 0 0 0 12.5 21H14l5 3v-3.181a6.498 6.498 0 0 0 5-6.319c0-2.789-1.76-5.16-4.226-6.083z"
  }));
};

ChatBubblesIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ChatBubblesIcon.defaultProps.solid = true;
export default ChatBubblesIcon;